<template>
    <div>
        <!-- Material Requests Table -->
        <div class="row">
            <div class="col-lg-12 mb-3">
                <data-table
                    v-if="tableLoaded"
                    :exportable = "false" title=""
                    :rows="getData.rowData"
                    :columns="columnData"
                    :perPage="perPage"
                    :rowsCount="rowsCount"
                    :currentPage="currentPage"
                    :pageCount="pageCount"
                    @rowClickCheck="onClickCheck"
                    @rowClickDelete="onDeleteRow"
                    @rowClickPDF="onPDF"
                    downloadPDF='general.buttons.download_material'
                    downloadPDFBlue='general.buttons.download_pickup'
                    @rowClickPDFBlue="onPDFBlue"
                    @rowClickView="onViewRow"
                    @rowClickPickup="onPickupRow"
                    @changePage="changePage"
                    @searchEvent="searchEvent"
                    @orderByEvent="orderByEvent"
                    >
                </data-table>
            </div>
        </div>

        <!-- Request Modal & Table2 -->
        <b-modal
            ref="requestModal"
            :title="requestTitle"
            size="lg"
            :ok-only="true"
            :ok-variant="'secondary'"
            :ok-title="$t('misc.cancel')"
        >
            <data-table
                :search="false"
                :exportable="false"
                v-if="tableLoaded2"
                :rows="getData.rowData2"
                :columns="columnData2"
                :perPage="perPage2"
                :rowsCount="rowsCount2"
                :currentPage="currentPage2"
                :pageCount="pageCount2"
                @changePage="changePage2"
                @orderByEvent="orderByEvent2"
                @rowClickCheck="onClickCheck2"
                @rowUnClickCheck="onClickUnCheck2"
                @rowCheckBox="onCheckBox2"
                >
            </data-table>
            <br/>
            <div>
                <i class="fa fa-2x fa-times red--text"></i> - {{$t('table.remove_assignation')}} &nbsp;&nbsp;
                <i class="fa fa-2x fa-arrow-circle-up blue--text"></i> - {{$t('table.request_picked_up')}} &nbsp;&nbsp;
            </div>
            <div>
                <i class="fa fa-check fa-2x green--text"></i> - {{$t('table.parts_available_to_assign')}} &nbsp;&nbsp;
                <i class="fa fa-2x fa-ban"></i> - {{$t('errors.stock_not_available')}}
            </div>
        </b-modal>

        <!-- Pick up Modal & Table3 -->
        <b-modal ref="pickupModal" :title="pickupTitle" size="lg" :ok-title="$t('misc.set_as_picked_up')" @ok="saveAction3" :cancel-title="$t('misc.cancel')" :ok-disabled="this.$store.state.ajax_in_progress">
            <div class="mt-2 row">
                <div class="col-sm-3">
                    <label>{{ $t('table.team_picked_up') }}</label>
                </div>
                <div class="col-sm-9">
                    <multiselect v-model="selectedTeamPickedUp"
                        :options="currentTeamPickedUp"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isTeamPickedUpLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="name" track-by="id"
                        :selectLabel="''"
                        @search-change="onTeamPickedUpSearch"
                        @input="updateTeamPickedUp"
                    >
                        <template slot="clear" slot-scope="props">
                            <div
                                v-if="selectedTeamPickedUp != null"
                                class="multiselect__clear"
                                @mousedown.prevent.stop="clearSelectedTeamPickedUp"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>

            <div class="row mt-2" v-if="model3.team_pickup_id != null">
                <div class="col-sm-3">
                    <label>{{ $t('table.user_picked_up') }}</label>
                </div>
                <div class="col-sm-9">
                    <multiselect v-model="selectedUserPickup"
                        :options="currentUserPickup"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isUserPickupLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="fullname" track-by="id"
                        :selectLabel="''"
                        @search-change="onUserPickupSearch"
                        @input="updateUserPickup"
                    >
                        <template slot="clear" slot-scope="props">
                            <div
                                v-if="selectedUserPickup != null"
                                class="multiselect__clear"
                                @mousedown.prevent.stop="clearSelectedUserPickup"
                            >
                            </div>
                        </template>
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>
            <div class="mt-2 row">
                <div class="col-sm-3">
                    <label for="pickupdate">{{ $t('table.pick_up_date') }}</label>
                </div>
                <div class="col-sm-9">
                    <flat-pickr  :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model3.picked_up_date" ></flat-pickr>
                </div>
            </div>

            <h5 class="mt-2">{{$t('misc.choose_parts_picked_up')}}</h5>
            <data-table
                :search="false"
                :exportable="false"
                v-if="tableLoaded3"
                :rows="getData.rowData3"
                :columns="columnData3"
                :perPage="perPage3"
                :rowsCount="rowsCount3"
                :currentPage="currentPage3"
                :pageCount="pageCount3"
                :showCheckBoxCheckedModel="to_pickup"
                @changePage="changePage3"
                @orderByEvent="orderByEvent3"
                @rowCheckBox="onCheckBox3"
                @rowEnterInput="rowEnterInput"
            >
            </data-table>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <confirm-dialog ref="pdfModal" :title="actionTitlePdf" @buttonClick="onDownloadPDF">
            <p class="m-0">{{ $t('messages.download_pdf') }}</p>
        </confirm-dialog>

        <confirm-dialog ref="pdfModalBlue" :title="actionTitlePdf" @buttonClick="onDownloadPDFBlue">
            <p class="m-0">{{ $t('messages.download_pdf') }}</p>
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import { Validator } from 'vee-validate';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import Multiselect from 'vue-multiselect';
Vue.component(Multiselect);

export default {
    name: 'change_order_request',
    components: {
        DataTable,
        flatPickr,
        ConfirmDialog,
        notificationIcons,
        Multiselect
    },
    props: {
        archived: {
            default: 0
        }
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.part.title'),
                    active: true
                }
            ],
            tableName: 'change_order_request',
            tableNameTranslated: Vue.i18n.translate('general.part.title'),
            actionTitle: '',
            actionTitlePdf: '',
            requestTitle: '',
            pickupTitle: '',
            toggleLabels: false,
            row: null,

            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'desc',
            sortBy: 'created_at',
            searchInput: '',

            tableLoaded2: false,
            row2: '',
            perPage2: 0,
            rowsCount2: 0,
            pageCount2: 0,
            currentPage2: 1,
            sortType2: 'asc',
            sortBy2: 'id',

            tableLoaded3: false,
            row3: '',
            perPage3: 0,
            rowsCount3: 0,
            pageCount3: 0,
            currentPage3: 1,
            sortType3: 'asc',
            sortBy3: 'id',

            requests: {},
            available_quantity: {},
            available_quantity_confirm: false,
            to_pickup: [], //for pickup
            getData: {
                rowData: [],
                rowData2: [],
                rowData3: [],
            },

            selectedTeamPickedUp: null,
            currentTeamPickedUp: [],
            isTeamPickedUpLoading: false,

            selectedUserPickup: null,
            currentUserPickup: [],
            isUserPickupLoading: false,

            model: {
                description: null,
                number: null,
                material: null,
                size: null,
                sizer: null,
                thk: null,
                thkr: null,
                dimension: null,
                total_qty: null,
                measureunit: null,
                unitweight: null,
                totalweight: null,
                note: null,
                prefab_material: false,
                erection_material: false,
            },

            model3: {
                user_pickup_id: null,
                team_pickup_id: null,
                team_store_id: null,
                picked_up_date: null,
                storage_id: null,
                heat_no: null,
                certificate_no: null,
                manufacturer: null,
                quantity: null,
            },

            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '160px',
                    field: '',
                    showDeleteButton: true,
                    showPDF: true,
                    showPDFBlue: true,
                    showViewButton: true,
                    showPickup: true,
                },
                {
                    label: Vue.i18n.translate('table.id'),
                    field: 'id',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.site_change_number'),
                    field: 'change_order.site_change_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.date'),
                    field: 'created_at',
                    numeric: false,
                    html: false,
                    datetime: true,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.archived'),
                    width: '90px',
                    field: 'archived',
                    showAsCheck: true,
                    numeric: false,
                    html: false,
                }
            ],
            columnData2: [
                {
                    width: '140px',
                    label: Vue.i18n.translate('misc.assign_from_stock'),
                    field: 'assigned',
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.qty_reserved'),
                    field: 'reserved',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.heat_no'),
                    field: 'heat_no',
                    numeric: false,
                    html: false,
                },
            ],
            columnData3: [
                {
                    label: Vue.i18n.translate('table.quantity'),
                    width: '140px',
                    field: 'quantity_wanted',
                    showInput: true,
                    customStyle: 'quantity_wanted_style'
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.storage'),
                    field: 'storage_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.heat_no'),
                    field: 'heat_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.certificate_no'),
                    field: 'certificate_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.manufacturer'),
                    field: 'manufacturer',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.qty_in_stock'),
                    field: 'quantity_stock',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted() {
        this.onLoadTable();
        this.buttonYes = Vue.i18n.translate('misc.yes');
        this.buttonNo = Vue.i18n.translate('misc.no');
        this.toggleLabels = {checked: this.buttonYes, unchecked: this.buttonNo};
    },
    methods: {
        // checkAll(e) {
        //     e.preventDefault();

        //     this.to_pickup = [];
        //     for (let i in this.getData.rowData3) {
        //         this.to_pickup.push(this.getData.rowData3[i].id);
        //     }
        // },
        // unCheckAll(e) {
        //     e.preventDefault();
        //     this.to_pickup = [];
        // },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 6000);
        },

        // Requests Table
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?from_stock=1&project_id='+this.$route.params.id+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType+'&filters[from_revision]=0&filters[archived]=' + this.archived).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.discipline_id == null || field.discipline_id == '') {
                            field.discipline = { 'name': '' };
                        }
                        field.status = Vue.i18n.translate('table.'+field.status);
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.model.company_id = null;
            this.model.file_id = null;
            this.model.currency = null;
            this.model.delay = null;
            this.model.status = null;
            this.model.heat_no = null;
            this.model.certificate_no = null;
            this.model.manufacturer = null;
            this.selectedCompany = null;
            this.model.project_part_id = null;
            this.selectedPart = null;
            this.removeFile();
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.model.company_id = this.row.company_id;
            this.model.currency = this.row.currency;
            this.model.delay = this.row.delay;
            this.model.status = this.row.status;
            this.model.heat_no = this.row.heat_no;
            this.model.certificate_no = this.row.certificate_no;
            this.model.manufacturer = this.row.manufacturer;
            this.selectedCompany = this.row.company;
            this.selectedPart = null;
            if (row.project_part_id) {
                this.selectedPart = [{name: row.number + (row.description ? ', ' + row.description : ''), id: row.project_part_id}];
            }
            this.model.project_part_id = row.project_part_id;
            this.removeFile();
            this.$refs.saveModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.part.material_request');
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onPDF (row) {
            this.actionTitlePdf = Vue.i18n.translate('general.buttons.download_material');
            this.row = row;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if(button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).get(
                {
                    export_pdf_request: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                            if (typeof res == 'undefined') {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                            } else {
                                Object.keys(res.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                });
                            }
                        });
                    } else {
                        miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                    }
                });
            }
            this.$refs.pdfModal.hide();
        },
        onPDFBlue (row) {
            this.actionTitlePdf = Vue.i18n.translate('general.buttons.download_pickup');
            this.row = row;
            this.$refs.pdfModalBlue.show();
        },
        onDownloadPDFBlue (button) {
            if(button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).get(
                {
                    export_pdf_pickup: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                            if (typeof res == 'undefined') {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                            } else {
                                Object.keys(res.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                });
                            }
                        });
                    } else {
                        miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                    }
                });
            }
            this.$refs.pdfModalBlue.hide();
        },
        onPickupRow (row, index) {
            this.pickupTitle = Vue.i18n.translate('general.part.pickup_parts');
            this.row = row;
            this.onLoadTable3();
            this.$refs.pickupModal.show();

            this.currentTeam       = [];
            this.currentUserPickup = [];

            this.selectedTeamPickedUp = null;
            this.selectedUserPickup   = null;

            this.model3.team_pickup_id = null;
            this.model3.user_pickup_id = null;
            this.model3.picked_up_date = null;
            this.model3.storage_id = null;
            this.model3.heat_no = null;
            this.model3.certificate_no = null;
            this.model3.manufacturer = null;
        },
        rowEnterInput(row, value) {
            this.requests[row.ids] = value;
        },
        onViewRow (row, index) {
            this.requestTitle = Vue.i18n.translate('general.part.requested_materials');
            this.row = row;
            this.onLoadTable2();
            this.$refs.requestModal.show();
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        if (clone.archived == 1) {
                            this.infoMsg(Vue.i18n.translate('general.construction.material_management.change_order_request.request') + ' ' + Vue.i18n.translate('messages.is_archived'));
                        } else {
                            this.infoMsg(Vue.i18n.translate('general.construction.material_management.change_order_request.request') + ' ' + Vue.i18n.translate('messages.is_not_archived'));
                        }
                    }
                });
                this.model[column.toString()] = null;
            }
        },
        saveAction (e) {
            e.preventDefault();

            this.uploadDoc().then(res => {
                let put_data = {
                    project_id:      this.$route.params.id,
                    user_id:         this.$store.state.user.user.id,
                    storage_id:      this.model.storage_id,
                    company_id:      this.model.company_id,
                    file_id:         this.model.file_id,
                    currency:        this.model.currency,
                    delay:           this.model.delay,
                    status:          this.model.status,
                    heat_no:         this.model.heat_no,
                    certificate_no:  this.model.certificate_no,
                    manufacturer:    this.model.manufacturer,
                    project_part_id: this.model.project_part_id,
                };

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                if (this.row) {
                    let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                    data.then(response => {
                        if(response.isError == false) {
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                            this.onLoadTable();
                            this.$refs.saveModal.hide();
                        } else {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        }
                    });
                } else {
                    let data = http.route(this.tableName).post(put_data, true);
                    data.then(response => {
                        if(response.isError == false) {
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                            this.onLoadTable();
                            this.$refs.saveModal.hide();
                        } else {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        }
                    });
                }
            });
        },

        //
        onCheckBox2 (row, index) {
            //if (typeof(this.requests[row.id]) == 'undefined') {
            //    this.requests[row.id] = row.id;
            //}
        },
        changePage2 (page) {
            this.currentPage2 = page;
            this.onLoadTable2();
        },
        orderByEvent2 (column, sort_type) {
            this.onLoadTable2();
        },
        onLoadTable2 () {
            let data = http.route(this.tableName + '/' + this.row.id+'?get_parts=1&material_management=1&page=' + this.currentPage2 + '&sort_by=' + this.sortBy2 + '&sort_order=' + this.sortType2).get().then(response => {
                if (!response.isError) {
                    this.perPage2 = response.pagination.limit;
                    this.rowsCount2 = response.pagination.totalEntries;
                    this.currentPage2 = response.pagination.currentPage;
                    this.pageCount2 = response.pagination.totalPages;
                    var data = response.data;
                    this.getData.rowData2 = response.data;
                    this.tableLoaded2 = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onClickCheck2 (row, index, column) {
            if (row) {
                row['change_order_request_part_id'] = row.id;

                http.route('project_stock/assign').post(row, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable2();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        onClickUnCheck2 (row, index, column) {
            if (row) {
                row['change_order_request_part_id'] = row.id;
                row['project_stock_id'] = row.assigned_id;
                row['unassign'] = true;

                http.route('project_stock/assign').post(row, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable2();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },

        //Project Stock
        onCheckBox3 (row, index) {
            let index2 = this.to_pickup.indexOf(row.id);
            if (index2 >= 0) {
                this.to_pickup.splice(index2, 1);
            } else {
                this.to_pickup.push(row.id);
            }
        },
        changePage3 (page) {
            this.currentPage3 = page;
            this.onLoadTable3();
        },
        orderByEvent3 (column, sort_type) {
            this.onLoadTable3();
        },
        onLoadTable3 () {
            this.requests = {};
            this.available_quantity = {};
            this.available_quantity_confirm = false;
            this.getData.rowData3 = [];
            http.route('project_stock?project_id='+this.$route.params.id+'&filters[change_order_request]='+this.row.id+'&page=' + this.currentPage3 + '&filters[status]=stock&filters[has_stock]=1&quantity_wanted='+this.row.id+'&sort_by=' + this.sortBy3 + '&sort_order=' + this.sortType3).get().then(response => {
                if (!response.isError) {
                    this.perPage3 = response.pagination.limit;
                    this.rowsCount3 = response.pagination.totalEntries;
                    this.currentPage3 = response.pagination.currentPage;
                    this.pageCount3 = response.pagination.totalPages;
                    var data = response.data;
                    this.getData.rowData3 = response.data;
                        data.forEach(field => {
                            this.requests[field.ids] = field.quantity_wanted;
                            this.available_quantity[field.ids] = field.quantity_stock;
                        });
                    this.tableLoaded3 = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        saveAction3(e) {
            e.preventDefault();

            if (Object.keys(this.requests).length > 0) {
                var more_than_existing = false;
                Object.keys(this.requests).forEach(key => {
                    if (this.available_quantity[key] < this.requests[key]) {
                        more_than_existing = true;
                    }
                });

                if (more_than_existing && !this.available_quantity_confirm) {
                    this.errorMsg(Vue.i18n.translate('errors.requested_more_than_available_sure'));
                    this.available_quantity_confirm = true;
                    return;
                }

                let put_data = {
                    requests:       this.requests,
                    manufacturer:   this.model3.manufacturer,
                    pickup_team_id: this.model3.team_pickup_id,
                    pickup_user_id: this.model3.user_pickup_id,
                    pickup_date:    this.model3.picked_up_date,
                }

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                if (this.row.id) {
                    http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                        if (response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.$refs.pickupModal.hide();
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('misc.material_set_as_picked_up'));
                        }
                    });
                } else {
                    this.errorMsg(Vue.i18n.translate('errors.you_must_select_at_least_a_part'));
                }
            } else {
                this.errorMsg(Vue.i18n.translate('errors.you_must_select_at_least_a_part'));
            }
        },

        //Selects
        onTeamPickedUpSearch(search) {
            if (search == '') {
                this.currentTeamPickedUp = [];

                return false;
            }

            this.isTeamPickedUpLoading = true;
            this.searchTeamPickedUp(search, this);
        },
        searchTeamPickedUp: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTeamPickedUp = response.data;
                }
                vm.isTeamPickedUpLoading = false;
            });
        }, 500),
        updateTeamPickedUp(team_pickup) {
            this.clearSelectedUserPickup();
            this.model3.team_pickup_id = (team_pickup != null) ? team_pickup.id : null;

            if (team_pickup != null) {
                let data = http.route('team/' + team_pickup.id +'/members?project_id='+this.$route.params.id).get();
				data.then(response => {
					this.currentUserPickup = response.data;
					this.isUserPickupLoading = false;
				});
            }
        },
        clearSelectedTeamPickedUp () {
            this.selectedTeamPickedUp  = null;
            this.model3.team_pickup_id = null;
            this.clearSelectedUserPickup();
        },
        onUserPickupSearch(search) {
            if (search == '') {
                this.currentUserPickup = [];

                return false;
            }

            this.isUserPickupLoading = true;
            this.searchUserPickupSearch(search, this);
        },
        searchUserPickupSearch: _.debounce((search, vm) => {
            var id = vm.model3.team_pickup_id;
            if (id != null) {
                let data = http.route('team/' + id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentUserPickup = response.data;
                    }
                    vm.isUserPickupLoading = false;
                });
            }
        }, 500),
        updateUserPickup(user_pickup) {
            this.model3.user_pickup_id = (user_pickup != null) ? user_pickup.user.id : null;
        },
        clearSelectedUserPickup () {
            this.selectedUserPickup    = null;
            this.model3.user_pickup_id = null;
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/project/construction/material_management/change_order_material_requests/change_order_request.vue